import React, { useState } from "react";
import axios from "axios";
import { CalendarClock, X, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const akhirBulanDepan = () => {
  const d = new Date();
  const last = new Date(d.getFullYear(), d.getMonth() + 2, 0);
  return `${last.getFullYear()}-${String(last.getMonth() + 1).padStart(2, "0")}-${String(last.getDate()).padStart(2, "0")}`;
};

// Tandai pelanggan agar dilewati isolir otomatis sampai tanggal tertentu
export const TundaIsolirDialog = ({ pelanggan, onClose, onSaved }) => {
  const [sampai, setSampai] = useState(pelanggan.tunda_isolir_sampai || akhirBulanDepan());
  const [catatan, setCatatan] = useState(pelanggan.tunda_isolir_catatan || "Konfirmasi bayar dobel bulan depan");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async (val) => {
    setSaving(true); setError("");
    try {
      await axios.patch(`${BACKEND_URL}/api/pelanggan/${pelanggan.id}/tunda-isolir`, { sampai: val, catatan }, { withCredentials: true });
      onSaved(); onClose();
    } catch (e) { setError(e.response?.data?.detail || "Gagal menyimpan"); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/75 backdrop-blur-sm flex items-center justify-center p-4" data-testid="tunda-isolir-dialog">
      <div className="bg-[#0f172a] border border-slate-700 rounded-2xl w-full max-w-sm shadow-2xl">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-800">
          <h3 className="text-sm font-bold text-white flex items-center gap-2"><CalendarClock className="w-4 h-4 text-amber-400" />Tunda Isolir</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-white" data-testid="tunda-isolir-close"><X className="w-4 h-4" /></button>
        </div>
        <div className="p-4 space-y-3">
          <p className="text-xs text-slate-300"><b className="text-white">{pelanggan.nama}</b> tidak akan diisolir otomatis sampai tanggal berikut, walau tagihannya lewat jatuh tempo.</p>
          <div>
            <label className="block text-[11px] text-slate-400 mb-1">Tunda sampai</label>
            <input type="date" value={sampai} onChange={(e) => setSampai(e.target.value)} data-testid="tunda-isolir-date" className="w-full px-3 py-2 bg-slate-950 border border-slate-700 rounded-xl text-xs text-white" />
          </div>
          <div>
            <label className="block text-[11px] text-slate-400 mb-1">Catatan</label>
            <input type="text" value={catatan} onChange={(e) => setCatatan(e.target.value)} data-testid="tunda-isolir-catatan" className="w-full px-3 py-2 bg-slate-950 border border-slate-700 rounded-xl text-xs text-white" />
          </div>
          {error && <p className="text-[11px] text-rose-400">{error}</p>}
        </div>
        <div className="p-3 border-t border-slate-800 flex gap-2">
          {pelanggan.tunda_isolir_sampai && (
            <button onClick={() => save(null)} disabled={saving} data-testid="tunda-isolir-cancel" className="flex-1 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-rose-300 text-xs font-bold">Batalkan Tunda</button>
          )}
          <button onClick={() => save(sampai)} disabled={saving || !sampai} data-testid="tunda-isolir-save" className="flex-1 py-2 rounded-lg bg-amber-500 hover:bg-amber-400 text-slate-950 text-xs font-bold flex items-center justify-center gap-1.5 disabled:opacity-50">
            {saving && <Loader2 className="w-3.5 h-3.5 animate-spin" />}Simpan
          </button>
        </div>
      </div>
    </div>
  );
};
